import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Switch, Route, Redirect } from 'react-router-dom'
import { routePaths, linkPaths, COURSENUM, OBJECT_ID } from '../urls'
import { getCertInfo } from '../actions'
import Requirements from './Requirements'
import Design from './Design'
import Review from './Review'

class Application extends React.Component {
  static propTypes = {
    finished: PropTypes.bool.isRequired,
    retrievedEditData: PropTypes.bool.isRequired,
    getCertInfo: PropTypes.func.isRequired,
  }

  UNSAFE_componentWillMount() {
    if (OBJECT_ID && !this.props.retrievedEditData) {
      this.props.getCertInfo()
    }
  }

  render() {
    if (this.props.finished) {
      window.location = `/instructor/achievements/${COURSENUM}/`
    }
    return (
      <div
        id="body_section"
        className="row opacity-0 position-relative p-0 m-5"
      >
        <section id="body_section_center" className="border bg-light m-0 pt-3">
          <Switch>
            <Route path={routePaths.design} component={Design} />
            <Route path={routePaths.requirements} component={Requirements} />
            <Route path={routePaths.review} component={Review} />
            <Redirect from={routePaths.wizard} to={linkPaths.design} />
          </Switch>
        </section>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    finished: state.finished,
    retrievedEditData: state.certInfo.retrievedEditData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCertInfo: () => {
      dispatch(getCertInfo())
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Application)
)
